<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
                <div class="td">
                  <el-button type="success" @click="addfns()">添加</el-button>
                </div>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column label="图片" >
            <template slot-scope="scope">
              <img :src="scope.row.thumb" width="100px" height="100px" class="head_pic"/>
            </template>
          </el-table-column>
          <el-table-column label="视频" width="250">
            <template slot-scope="scope">
            <el-button style="margin-left: 15px;" size="small" type="success" @click="preview1(scope.row.video)">点击查看</el-button>
          </template>
          </el-table-column>
           <el-table-column label="添加时间" width="250">
            <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="排序" width="180">
            <template slot-scope="scope">
              <el-button @click="setup(scope.row)">上移</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="danger" @click="deletefn(11, 56, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(11, 56)">批量删除</el-button>
      </div>
    </div>
    <el-dialog title="首页视频图片上传" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <tr>
          <td class="tdleft">标题</td>
          <td class="tdright">
            <el-input v-model="form.title" class="input title"></el-input>
          </td>
        </tr>
        <tr>
          <td class="tdleft">图片</td>
          <td class="tdright">
            <el-upload
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic1"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" />
          </el-dialog>
          </td>
        </tr>
        <tr>
          <td>视频</td>
          <td>
            <el-upload
              class="upload-demo"
              :action="url"
              :limit="1"
              :on-success="onSuccess1"
              :on-remove="handleRemoveVideo"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :before-upload="beforeUploadVideo"
              @mouseover.native="getVidUrl"
              :on-exceed="exceed">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button style="margin-left: 15px;" size="small" type="success" @click="preview1()">点击预览</el-button>
            </el-upload>
          </td>
        </tr>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addfn1()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible1">
      <video-player ref="videoPlayer" :playsinline="true"  :options="playerOptions"></video-player>
    </el-dialog>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * lx
 * 首页视频管理
 */
import vuedraggable from 'vuedraggable'
import playVideo from '../../app/method/playVideo'
import filters from '../method/filter'
export default {
  components: {vuedraggable},
  mixins: [playVideo, filters],
  data()
  {
    return {
      url: '',
      form: {
        title: '',
        thumb: '',
        video: ''
      },
      //预览弹框
      dialogVisible: false,
      dialogVisible1: false,
      dialogFormVisible: false,
      //预览路径
      dialogImageUrl: '',
      pageSize: 20,
      currentPage: 1,
      tableData: [],
      show1: false,
      show2: false,
      hideUploadEdit: false,
      countSum: null,
      datalength: null
    }
  },
  // updated()
  // {
  //   this.lastData = this.tableData.slice(-10)
  //   this.lastData.forEach((data, index) =>
  //   {
  //     let obj = {
  //       cmd: 'updateAtt',
  //       _major: 11,
  //       _minor: 56,
  //       retAtt: 1,
  //       id: data.id,
  //       orders: `${index}`
  //     }
  //     window.post.getPost(obj).then((ret) =>
  //     {
  //     })
  //   })
  // },
  mounted()
  {
    this.getList()
  },
  created()
  {
    this.getCount()
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if (userInfo.userno === 'admin' || userInfo.role.indexOf(1) !== -1 || userInfo.role.indexOf(5) !== -1 || userInfo.role.indexOf(8) !== -1)
    {
      this.show1 = true
      this.show2 = true
    }
    else
    {
      this.show1 = false
      this.show2 = false
    }
  },
  methods: {
    addfns()
    {
      this.dialogFormVisible = true
    },
    getCount()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 56,
        _exp: 'name = ?',
        types: 's',
        vals: '首页视频'
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.datalength = ret.length + 1
      })
    },
    addfn1()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 56,
        retAtt: 1,
        type: 2,
        name: '首页视频',
        addtime: (Date.parse(new Date()) / 1000),
        title: this.form.title,
        thumb: this.form.thumb,
        video: this.form.video,
        orders: this.datalength,
        shows: 0
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 0)
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.form.thumb = ''
          this.form.video = ''
          this.dialogFormVisible = false
          this.getList()
        }
        else
        {
          this.$message({message: '添加失败', type: 'error', customClass: 'mzindex'})
          this.form.thumb = ''
          this.form.video = ''
          this.dialogFormVisible = false
          this.getList()
        }
      })
    },
    setup(row)
    {
      if (row.orders === this.datalength)

        this.$message({message: '此条数据已是第一位，不能再次上移', type: 'error', customClass: 'mzindex'})
      else
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 56,
          _exp: 'orders=?',
          types: 'i',
          vals: row.orders + 1
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length > 0)
          {
            let obj = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 56,
              retAtt: 1,
              id: ret[0].id,
              orders: ret[0].orders - 1
            }
            window.post.getPost(obj)
            let objs = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 56,
              retAtt: 1,
              id: row.id,
              orders: row.orders + 1
            }
            window.post.getPost(objs).then((retss) =>
            {
              if (retss)
              {
                this.$message({message: '上移成功', type: 'success', customClass: 'mzindex'})
                this.getList()
              }
            })
          }
        })
      }
    },
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    preview()
    {
      this.playerOptions.sources[0].src = this.form.thumb
      this.dialogVisible1 = true
    },
    preview1(thumb)
    {
      this.playerOptions.sources[0].src = thumb ? thumb : this.form.video
      if (this.playerOptions.sources[0].src)
        this.dialogVisible1 = true
      else
        this.$message({message: '您还没有上传视频，暂可内容预览', type: 'error', customClass: 'mzindex'})
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    getList()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 56,
        _exp: 'type=?',
        types: 's',
        vals: 2,
        orderby: 'orders DESC'
      }
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        console.log(ret)
        ret.forEach((item) =>
        {
          temp.push({
            id: item.id,
            type: item.type,
            title: item.title,
            name: item.thumb.substring(item.thumb.lastIndexOf('/') + 1, item.thumb.length),
            addtime: +item.addtime,
            thumb: item.thumb,
            shows: item.shows,
            video: item.video,
            orders: item.orders
          })
          this.tableData = temp
        })
      })
    },
    delfn(row)
    {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'delete',
          _major: 11,
          _minor: 56,
          id: row.id
        }
        window.post.getPost(obj).then((ret) =>
        {
          this.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
          this.getList()
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    cancelshowfn(row)
    {
      this.$confirm('此操作取消置顶, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 56,
          retAtt: 1,
          id: row.id,
          shows: 0
        }
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 0)
          {
            this.$message({message: '取消置顶成功', type: 'success', customClass: 'mzindex'})
            this.getList()
          }
          else
            this.$message({message: '取消置顶失败', type: 'error', customClass: 'mzindex'})
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    showfn(row)
    {
      this.$confirm('此操作将置顶视频, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'query',
          _major: 11,
          _minor: 56,
          retAtt: 1,
          _exp: 'id>0 and type = 2'
        }
        window.post.getPost(obj).then((ret) =>
        {
          ret.forEach((item) =>
          {
            if (row.id === item.id)
            {
              let obj = {
                cmd: 'updateAtt',
                _major: 11,
                _minor: 56,
                retAtt: 1,
                id: row.id,
                shows: 1
              }
              window.post.getPost(obj).then((ret) =>
              {
                if (ret.ret === 0)
                {
                  this.$message({message: '置顶成功', type: 'success', customClass: 'mzindex'})
                  this.getList()
                }
                else
                  this.$message({message: '置顶失败', type: 'error', customClass: 'mzindex'})
              })
            }
            else
            {
              let obj = {
                cmd: 'updateAtt',
                _major: 11,
                _minor: 56,
                retAtt: 1,
                id: item.id,
                shows: 0
              }
              window.post.getPost(obj).then((ret) =>
              {
              })
            }
          })
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    getVidUrl()
    {
      let that = this
      window.public.onUploadVideo(that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //上传视频
    onSuccess1(response)
    {
      let that = this
      window.public.onVideoSuccess(response, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 56,
        _exp: 'orders > ?',
        types: 'i',
        vals: row.orders,
        orderby: 'orders ASC'
      }
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length)
        {
          let dataId = []
          let dataOrders = []
          ret.forEach(item =>
          {
            dataId.push(item.id)
            dataOrders.push(`${item.orders - 1}`)
          })
          let objcontent = {
            cmd: 'updateAtts',
            _major: 11,
            _minor: 56,
            retAtt: 1,
            separator: ',',
            ids: dataId.toString(),
            orders: dataOrders.toString()
          }
          window.post.getPost(objcontent).then((res) =>
          {
            if (res.ret === 0)
              window.public.deletefn(major, minor, row, that)
          })
        }
        else
          window.public.deletefn(major, minor, row, that)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/backer/assembly/FirVideoLB.vue